import { captureConsoleIntegration } from "@sentry/integrations";
import * as Sentry from "@sentry/react";
import { reactRouterV6BrowserTracingIntegration } from "@sentry/react";
import axios from "axios";
import { userStorage } from "features/auth/AuthUtils";
import { isStytchSdkApiError } from "features/auth/StytchUtils";
import LogRocket from "logrocket";
import { useEffect } from "react";
import { createRoutesFromChildren, useNavigationType } from "react-router";
import { matchRoutes, useLocation } from "react-router-dom";
import { AppConfig } from "shared/config/AppConfig";

const STYTCH_IGNORED_ERROR_NAMES = [
  "SDKAPIUnreachableError",
  "StytchAPIUnreachableError",
];
const STYTCH_IGNORED_ERROR_TYPES = ["user_unauthenticated"];

export const appInitSentry = () => {
  if (!AppConfig.sentry) {
    return;
  }
  Sentry.init({
    ...AppConfig.sentry,
    autoSessionTracking: false,
    integrations: [
      captureConsoleIntegration(),
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    beforeSend: (event, hint) => {
      const ex = hint.originalException;
      // Don't send API errors to frontend sentry
      if (axios.isAxiosError(ex)) {
        return null;
      }
      if (
        (ex instanceof Error && STYTCH_IGNORED_ERROR_NAMES.includes(ex.name)) ||
        (isStytchSdkApiError(ex) &&
          STYTCH_IGNORED_ERROR_TYPES.includes(ex.error_type))
      ) {
        // Don't send expected Stytch errors to frontend sentry
        return null;
      }
      if (ex instanceof DOMException && ex.name === "NotAllowedError") {
        // e.g. Clipboard readText failed
        return null;
      }
      // This exception comes from https://github.com/jetbridge/axios-jwt/blob/master/src/authTokenInterceptor.ts#L94
      if (
        hint.originalException instanceof Error &&
        hint.originalException.message.includes(
          "Failed to refresh auth token: Network Error",
        )
      ) {
        return null;
      }
      event.extra ||= {};
      if (AppConfig.logRocket) {
        event.extra["lr_sessionURL"] = LogRocket.sessionURL;
      }
      return event;
    },
  });
  const userData = userStorage.get();
  if (userData) {
    Sentry.setUser({ id: userData.userId, email: userData.email });
  }
};
